export const webProjects = [
  {
    title: "the-food-order-app",
    subtitle: "HTML / CSS / React Js / Webpack / Hooks",
    description: "shopping cart to add and order food using the react js hooks",
    image: "/images/web/project-5.png",
    link: "https://yoniberplay.github.io/the-food-order-app/",
  },
  {
    title: "SDQRealEstate",
    subtitle: "ASP.NET MVC / SQL Server / Rest APIs / Entity / Identity / JWT",
    description:
      "RealState with api for the management of users, agents, adm and developers.",
    image: "/images/web/project-1.png",
    link: "https://github.com/yoniberplay/SDQRealEstate",
  },
  {
    title: "POKEDEX",
    subtitle: "ASP.NET MVC / SQL Server / CSS",
    description: "Pokedex app, using asp net core mvc 6 and Sql server.",
    image: "/images/web/project-2.png",
    link: "https://github.com/yoniberplay/POKEDEX",
  },
  {
    title: "Expenses",
    subtitle: "HTML / CSS / React Js / Webpack",
    description: "add expenses and see the statistics for annual expenses",
    image: "/images/web/project-9.png",
    link: "https://yoniberplay.github.io/aplicacion-react/",
  },
  {
    title: "Social network",
    subtitle: "ASP.NET MVC/ SQL Server / Entity",
    description:
      "add friends through their username and comment on their photos",
    image: "/images/web/project-3.png",
    link: "https://github.com/yoniberplay/Red-Social",
  },
  {
    title: "E-Market",
    subtitle: "ASP.NET MVC/ SQL Server / Razor ",
    description:
      "Register and log in to the web app to buy and sell items online.",
    image: "/images/web/project-4.png",
    link: "https://github.com/yoniberplay/E-Market",
  },
  {
    title: "BlackJack-Game",
    subtitle: "HTML / CSS / JS / Vite",
    description:
      "Play a game of blackjack, to win you must have 21 points or the closest",
    image: "/images/web/project-6.png",
    link: "https://yoniberplay.github.io/BlackJack-Game/",
  },
  {
    title: "Task-app",
    subtitle: "HTML / CSS / JS / Vite",
    description:
      "Manage daily tasks, add, delete or mark as completed your tasks.",
    image: "/images/web/project-7.png",
    link: "https://yoniberplay.github.io/Task-app/",
  },
  {
    title: "Library",
    subtitle: "HTML / CSS / React Js / Webpack / Firebase / Hooks",
    description: "Basic interface for a library",
    image: "/images/web/project-10.png",
    link: "https://yoniberplay.github.io/books-app/",
  },
];

export const Desktop = [
  {
    title: "SellPoint-v1.0",
    subtitle: "C# / Sql Server / Forms",
    description:
      "Solution to manage credit entities using 3 Tier Architecture and Client Server Architecture.",
    image: "/images/desktop/project-5.png",
    link: "https://github.com/yoniberplay/SellPoint-v1.0",
  },
  {
    title: "Group Chat ",
    subtitle: "Java / JavaFX / Threads",
    description:
      "Group Chat to send and receive files in the same lan network. Multiple clients and one server",
    image: "/images/desktop/project-6.png",
    link: "https://github.com/yoniberplay/JavaFX-Group-Chat-Application-with-files-transfer",
  },
  {
    title: "Integral Calculator",
    subtitle: "Python / Sympy / tkinter ",
    description:
      "Definite and indefinite integration, calculate the arc length or rectification of a curve and graph them.",
    image: "/images/desktop/project-7.png",
    link: "https://github.com/yoniberplay/Calculadora_Integrales",
  },
];

export const Uxui = [
  {
    title: "Media player",
    subtitle: "Design UX/UI Media player",
    description:
      "Media player design based on layout and user experience using C# Forms",
    image: "/images/ui-ux/project-7.png",
    link: "https://github.com/yoniberplay/Reproductor",
  },
  {
    title: "Browser",
    subtitle: "Design UX/UI Browser",
    description: "Web browser based design and user experience using C# Forms",
    image: "/images/ui-ux/project-8.png",
    link: "https://github.com/yoniberplay/Yonib_Browser",
  },
  {
    title: "Text editor",
    subtitle: "Design UX/UI Text editor",
    description: "Text editor based design and user experience using C# Forms",
    image: "/images/ui-ux/project-9.png",
    link: "https://github.com/yoniberplay/Editor_Texto",
  },
];

export const testimonials = [
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/1.jpg",
    name: "Jesse Hicks",
    company: "Zoozle",
  },
  {
    quote:
      "Lorem ipsum dolor sit amet consectetur adipisicing elit. Culpa quod necessitatibus quidem impedit facilis? Distinctio laboriosam veritatis recusandae minus. Voluptatum accusantium hic laudantium soluta ea sapiente cupiditate officia maiores itaque.",
    image: "https://randomuser.me/api/portraits/men/94.jpg",
    name: "Ruben Alvarez",
    company: "Dooble.io",
  },
];

export const skills = [
  "C# /.Net / .Net Framework / SOAP / REST ",
  "Identity / Razor / Entity framework",
  "JWT / Azure / Firebase",
  "Node / Express / Sequelize",
  "HTML / CSS / JS / React / Vuej",
  "SQL Server / MySQL / Oracle ",
  "Java EE / Spring / Maven / Hibernate",
  "Material UI / Bootstrap / Tailwind / Vuetify",
];
